import { Grid } from "@material-ui/core";
import { required, TextInput } from "react-admin";
import { PlatformWithOrderCheckboxGroupInput } from "../../component/platform-components";
import { RegionCheckboxGroupInput } from "../../component/region-components";
import { ShelfDateTimeInput } from "./shelf-date-time-input";
import { TemplateSelectInput } from "./template-select-input";

export const CategoryListForm = () => {
  return (
    <Grid container spacing={1} fullWidth>
      {/* <Grid item sm={12} md={12}>
        <AutoCompleteEpisode
          clearAlwaysVisible={true}
          fullWidth
          formData={formData}
          {...rest}
          allowEmpty={true}
          fetchProgramme={fetchProgramme}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput
          label="Programme Name"
          source="programme_name"
          disabled
          fullWidth
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput
          label="Programme ID"
          source="programme_id"
          disabled
          validate={required()}
          fullWidth
        />
      </Grid> */}

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["loop_text"]} defaultValue={"loop_text"} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};
